import {
    LOGIN,
    GET_AUTH_USER,
    UPDATE_AUTH_USER,
    SEND_OTP,        // 👈 Import
    VERIFY_OTP,
    LOGOUT
} from 'redux/actions/types';

const INIT_STATE = {
    authUser: null,
    otpSent: false,  
    otpVerified: false
};

const authReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case LOGIN: {
            return { ...state, authUser: action.payload };
        }
        case GET_AUTH_USER: {
            return { ...state, authUser: action.payload };
        }
        case UPDATE_AUTH_USER: {
            return { ...state, authUser: action.payload };
        }
        case LOGOUT: {
            return { ...state, authUser: null };
        }

        //
        case SEND_OTP: {
        
            return { ...state, otpSent: true };
        }
        case VERIFY_OTP: {
        
            return {
                ...state,
                authUser: action.payload,
                otpVerified: true,
                otpSent: false 
            };
        }

        default: {
            return state;
        }
    }
};


export default authReducer;